import { useDocumentTitle } from "../../lib/date"

const Favorite = () => {
  useDocumentTitle('Favorite Pokemons')
  return (
  <div className='card d-flex justify-content-center align-items-center m-5 p-5' style={{ minHeight: "60.9vh" }}>
    <h1 className='alert alert-info'>Under Construction</h1>
    <p className='alert alert-info'>Soon you will see your favorite pokemon here</p>
  </div>
)}

export default Favorite